import { Breadcrumb } from '@/legacy/components/Breadcrumb'
import type { Category } from '@/legacy/models'

import type { BreadcrumbProps } from '../Breadcrumb/Breadcrumb'

import { generateBreadcrumb } from './utils'

interface Props extends Pick<BreadcrumbProps, 'color' | 'ariaHidden'> {
  category?: Category
  noHref?: boolean
}

function CategoryBreadcrumb({ category, noHref, ...props }: Props) {
  if (!category) {
    return null
  }

  const breadcrumb = generateBreadcrumb(category, [], { noHref })
  return <Breadcrumb items={breadcrumb} {...props} />
}

export default CategoryBreadcrumb
